import Cookies from 'js-cookie'

let params = {
  expires: 7
}

// 判断如果是浮印的域名，那么种 cookie 在一级域名下
if (window.location.href.indexOf(import.meta.env.VITE_APP_HOST) >= 0) {
  params.domain = import.meta.env.VITE_APP_HOST
}

/**
 * 当前用户查看的商户 ID
 * @type {string}
 */

const KeyMerchantId = 'Y-Pc-Bar-Merchant-Id'

export function getMerchantId() {
  return Cookies.get(KeyMerchantId, params)
}

export function setMerchantId(merchantId) {
  return Cookies.set(KeyMerchantId, merchantId, params)
}

export function removeMerchantId() {
  return Cookies.remove(KeyMerchantId, params)
}
